import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router';
import { routes } from '@config/routes';
import { BrandLoader } from '@shared/ui';

export function AuthCallbackPage() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isAuthenticated) navigate(routes.dashboard, { replace: true });
  }, [auth.isAuthenticated, navigate]);

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4">
      <BrandLoader decorative />
      <p className="text-neutral-500">Completing sign-in…</p>
    </div>
  );
}
